<template>
  <div>
    <div class="dialer-container">
      <b-row style="width:100%;margin-right: 0px;margin-left: 0px;">
        <b-col cols="2" style="">
          <vue-country-code
            class="country-select"
            :dropdownOptions="{ disabledDialCode: false }"
            @onSelect="onSelect"
            defaultCountry="us"
            :enabledCountryCode="true"
            :disabledFetchingCountry="true"
            :preferredCountries="[]"
            :onlyCountries="dialable_countries"
          >
          </vue-country-code>
        </b-col>
        <b-col cols="8">
          <b-form-input
            class="dial-pad-number"
            v-model="number"
            type="tel"
            placeholder="Enter phone number"
          ></b-form-input>
        </b-col>
        <b-col cols="1">
          <font-awesome-icon
            class="dialer-call-button "
            icon="phone-alt"
            @click="MakeOutboundCall()"
            size="lg"
          />
        </b-col>
      </b-row>
    </div>

    <div v-if="dialpadToggle" class="key-pad">
      <b-row>
        <b-col cols="4" @click="keyDial('1')" class="key">
          <span class="number"> 1 </span>
          <span class="alphabet"> </span>
        </b-col>
        <b-col cols="4" @click="keyDial('2')" class="key">
          <span class="number"> 2 </span>
          <span class="alphabet"> ABC </span>
        </b-col>
        <b-col cols="4" @click="keyDial('3')" class="key">
          <span class="number"> 3 </span>
          <span class="alphabet"> DEF </span>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4" @click="keyDial('4')" class="key">
          <span class="number"> 4 </span>
          <span class="alphabet"> GHI </span>
        </b-col>
        <b-col cols="4" @click="keyDial('5')" class="key">
          <span class="number"> 5 </span>
          <span class="alphabet"> JKL </span>
        </b-col>
        <b-col cols="4" @click="keyDial('6')" class="key">
          <span class="number"> 6 </span>
          <span class="alphabet"> MNO </span>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4" @click="keyDial('7')" class="key">
          <span class="number"> 7 </span>
          <span class="alphabet"> PQRS </span>
        </b-col>
        <b-col cols="4" @click="keyDial('8')" class="key">
          <span class="number"> 8 </span>
          <span class="alphabet"> TUV </span>
        </b-col>
        <b-col cols="4" @click="keyDial('9')" class="key">
          <span class="number"> 9 </span>
          <span class="alphabet"> WXYZ </span>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <span class="number"> </span>
          <span class="alphabet"> </span>
        </b-col>
        <b-col cols="4" @click="keyDial('0')" class="key">
          <span class="number"> 0 </span>
          <span class="alphabet"> </span>
        </b-col>
        <b-col cols="4" @click="clearNumber()" class="key">
          <span class="number">
            <!-- <font-awesome-icon icon="arrow-left" size="sm" /> -->
            <font-awesome-icon v-if="number.length > 0" icon="backspace" size="sm" />

          </span>
          <span class="alphabet"></span>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import "amazon-connect-streams";
import "amazon-connect-chatjs";
import { makeOutboundCall, onAddConference } from "./../../lib/CallActions";
import { checkThirdPartyStatus } from "../../lib/ContactRefresh";
import store from "../../store";

export default {
  name: "dialer",
  data() {
    return {
      number: "",
      dialPadToggleStatus: true,
      defaultCode: "+1",
    };
  },
  created() {
    this.$store.dispatch("call/setCountryCode", {
      country: "us",
      code: "+1",
    });
    // this.$store.dispatch("call/updateCountry", { country: "us", code: "+1" });
  },
  methods: {
    onSelect({ name, iso2, dialCode }) {
      console.log(name, iso2, dialCode);
      this.$store.dispatch("call/setCountryCode", {
        country: name,
        code: "+" + dialCode,
      });
    },
    keyDial(number) {
      this.number = this.number + number;
    },
    async MakeOutboundCall() {
      var mobileNumberPattern = /^\d{7,12}$/;

      var countryCodePattern = /^\+\d{1,4}/;

      if(countryCodePattern.test(this.number)){

        console.log("COUNTRY CODE IS PRESENT",this.number)
        let postData = {};
            postData.action = "SHOW_NOTIFICATION";
            postData.type = "COUNTRY_CODE_EXISTS";
            // postMessage = "Outbound call not connected";
            parent.postMessage(postData,"*" );
      }else{
        console.log("COUNTRY CODE IS NOT PRESENT",this.number)
        if(mobileNumberPattern.test(this.number)){
        console.log("VALID MOBILE NUMBER")
        if (this.pageroute == "home") {
          console.log("this is country code", store.getters.countryCode);

          makeOutboundCall(
            "Unknown Caller",
            this.countryCode.code + this.number
          );
          this.$store.dispatch("actions/setOutboundCall", true);
        } else {
          await onAddConference("number", this.countryCode.code + this.number);
          let confStatus = await checkThirdPartyStatus();
          if (confStatus == "success") {
            this.$store.dispatch("call/setCallType", "conference");
            this.$store.dispatch("actions/callSubNavigation", "call");
          } else {
            let postData = {};
            postData.action = "SHOW_NOTIFICATION";
            postData.type = "ERROR";
            // postMessage = "Outbound call not connected";
            parent.postMessage(postData,"*" );
          }
        }
      }else{
        let postData = {};
            postData.action = "SHOW_NOTIFICATION";
            postData.type = "INAVLID_PHONE_NUMBER";
            // postMessage = "Outbound call not connected";
            parent.postMessage(postData,"*" );
          }


      }


  

      },
    clearNumber() {
      this.number = this.number.slice(0, this.number.length - 1);
      console.log("NUMBER", this.number);
    }
  },
  computed: {
    ...mapGetters([
      "dialable_countries",
      "homeSubNav",
      "callSubNav",
      "countryCode",
      "pageroute",
      "dialpadToggle",
      "",
    ]),
  },
};
</script>

<style>
.vue-country-select {
  border: none !important;
  font-size: 18px;
  margin-top: 3px;
}

.vue-country-select .dropdown {
  padding: 0px !important;
  margin-top: 7px !important;
}

.vue-country-select .dropdown:hover {
  background-color: transparent !important;
}

.vue-country-select .dropdown-list {
  z-index: 1;
  padding: 0;
  margin: 0;
  text-align: left;
  list-style: none;
  max-height: 215px !important;
  overflow-y: scroll;
  position: absolute;
  top: 100%;
  left: -14px !important;
  background-color: #fff;
  border: 1px solid #ccc;
  width: 339px !important;
  margin-top: 17px !important;
}
.vue-country-select .dropdown.open {
  background-color: transparent !important;
}
</style>

<style scoped>
.key {
  cursor: pointer;
}

.key-pad {
  /* height: 250px;
  padding: 20px 52px 10px 52px;
  position: fixed;
  bottom: 220px;
  background: #fff;
  box-shadow: 0 -2px 4px rgb(0 0 0 / 8%);
  width: 369px;
  margin: 0px -10px;
  left: 0;
  z-index: 2; */

  height: 210px;
  padding: 10px;
  position: fixed;
  bottom: 25px;
  background: #fff;
  box-shadow: 0 -4px 4px rgb(0 0 0 / 8%);
  width: 340px;
  margin: 0 -10px;
  z-index: 2;
}

.key-set {
  padding: 10px;
}

.key-set :hover {
  background-color: #ebeff3;
  cursor: pointer;
}

.key .number {
  color: #12344d;
  font-size: 24px;
}

.key .alphabet {
  color: #475867;
  font-size: 10px;
}

.key-pad span {
  display: block;
  text-align: center;
}

.dialer-container {
  background-color: #12344d;
  /* background-color: #08255c; */
  display: flex;
  align-items: center;
  height: 56px;
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%), 0 0 4px 0 rgb(0 0 0 / 10%);
  font-size: 14px;
  color: #fff;
  margin: -10px -10px 5px -10px;
}

.dialer-call-button {
  color: rgb(255, 255, 255);
  background: #0f9d58;
  font-size: 35px;
  padding: 10px;
  border-radius: 50%;
}

/* .dialer-call-button:hover {
  background: #6fdfc8;
} */

.dial-pad-country-code {
  border: 1px solid #ccc;
  border-right: none;
  margin-right: -5px !important;
  border-radius: 0px;
  color: #495057;
}

.dial-pad-number {
  border: none;
  background: #12344d;
  color: #fff;
}

.dial-pad-number:focus {
  outline: none !important;
  box-shadow: none !important;
  border: 1px solid #ccc !important;
  border: none !important;
}

.dial-pad-button {
  border: 1px solid #ccc;
  border-left: none;
  margin-left: -5px;
  border-radius: 0px;
  color: #ccc;
}

.dial-pad-button:hover {
  background: #ffffff;
  border: 1px solid #ccc;
  border-left: none;
  color: #6c757d !important;
}

.dial-pad-button:active {
  background: #ffffff !important;
  border: 1px solid #ccc !important;
  color: #00425f !important;
  border-left: none;
  color: #6c757d !important;
}

.dialpad-container {
  text-align: center;
  margin-top: 50px;
}

.button-row {
  margin-top: 10px;
}

.dialpad-button {
  width: 23%;
  height: 65px;
  margin-right: 5px;
  margin-left: 5px;
}

.dialpad-number {
  font-size: 19px;
  font-weight: bold;
}

.dialpad-letters {
  font-size: 13px;
  color: #ccc;
}

.dialpad-filler {
  visibility: hidden;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
}
</style>
